module.exports = __webpack_public_path__ + "static/img/52.3892d73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/52.png
// module id = ffqc
// module chunks = 0